import type { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Toast } from '../../lib/ui/Toast';
import type { QuestionModel } from '../logic';
import { GraphicSelectModel, MultiSelectModel } from './AnswersView';

export const ValidationErrorToast: FC<{ questionModel: QuestionModel; className?: string | null }> = observer(
  ({ questionModel, className }) => {
    let text = '';

    if (questionModel instanceof MultiSelectModel && questionModel.responseLimitsReached) {
      text = 'Выбрано максимальное количество ответов';
    } else if (questionModel.validationErrors.noSelectedAnswersError) {
      text = questionModel instanceof GraphicSelectModel ? 'Поставьте оценку, чтобы продолжить' : 'Выберите вариант, чтобы продолжить';
    }

    if (!text) {
      return null;
    }

    return <Toast className={className} text={text} />;
  }
);
